import styled from 'styled-components';
import { WebsiteTypographyProps } from './websiteTypes';
import { websiteTypographyMixin } from './websiteTypographyMixin';

export const WebsiteTypography = styled.div<WebsiteTypographyProps>`
  ${({ size, kind, type }) => websiteTypographyMixin(kind, size, type)}
`;
